import DeviceGroupScreensTab from './DeviceGroupScreensTab';

export default DeviceGroupScreensTab;
